import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ComponentType, PropsWithChildren } from 'react';

const base = <SP, HP>(
  hook: (props: Partial<SP>) => HP,
  Source: ComponentType<HP & SP & any>,
  tracked = false
) => {
  const base = (props: SP) => (
    <Source {...(hook(props) || ({} as any))} {...props} />
  );

  const Result: any = tracked ? observer(base) : base;

  Result.Original = Source;
  Result.hook = hook;

  return (Result as any) as ComponentType<Partial<HP> & Partial<SP> & any> & {
    Original: ComponentType<HP & SP>;
    hook: typeof hook;
  };
};

/**
 * Wrap component with hook function with will be called in HOC component render
 */
const hoc = function<SP, HP>(
  hook: (props: Partial<SP>) => HP,
  Source: ComponentType<HP & SP>
) {
  const Result: any = (props: SP) => (
    <Source {...(hook(props) || ({} as any))} {...props} />
  );

  Result.Original = Source;
  Result.hook = hook;

  return (Result as any) as ComponentType<Partial<HP> & Partial<SP>> & {
    Original: ComponentType<HP & SP>;
    hook: typeof hook;
  };
};

hoc.observer = <SP, HP>(
  hook: (props: Partial<SP>) => HP,
  Source: ComponentType<HP & SP & any>
) => base(hook, Source, true);

export { hoc };
